import { CheckOutlined } from "@ant-design/icons";
export default function UserTag({ label, email, onSelect, orgId }) {
  return (
    <div
      style={{
        height: "57px",
        maxWidth: "300px",
        display: "flex",
        flexDirection: "row",
        overflow: "hidden",
      }}
      onClick={() => {
        onSelect?.(orgId, label);
      }}
    >
      <div
        style={{
          width: "22%",
          height: "100%",
          alignContent: "center",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: "40px",
            height: "40px",
            borderRadius: "80px",
            backgroundColor: "rgba(93, 106, 192, 1)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "20px",
            color: "white",
          }}
        >
          {label.substr(0, 1)}
        </div>
      </div>
      <div
        style={{
          width: "78%",
          height: "100%",
          display: "flex",
          justifyContent: "space-around",
          flexDirection: "column",
          overflow: "hidden",
          marginLeft: "10px",
        }}
      >
        <div style={{ fontSize: "16px", fontWeight: 400 }}>
          {label || ""}
          {/* {selected && <CheckOutlined style={{ float: "right" }} />} */}
        </div>
        <div
          style={{
            width: "100%",
            fontSize: "14px",
            fontWeight: 400,
            color: "#717171",
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
          }}
          title={email || "(email unavailable)"}
        >
          {email || "(email unavailable)"}
        </div>
      </div>
    </div>
  );
}
